/* eslint-disable max-classes-per-file */

export class Connection {
  bare: WebSocket;

  constructor(url: string, protocols: string[]) {
    this.bare = new WebSocket(url, protocols);
  }

  // eslint-disable-next-line class-methods-use-this
  open() {
    // nothing todo for websocket
  }

  close() {
    this.bare.close();
  }

  send(data: string) {
    this.bare.send(data);
  }

  isOpen(): boolean {
    if (this.bare.readyState === WebSocket.CONNECTING || this.bare.readyState === WebSocket.OPEN) {
      return true;
    }
    return false;
  }

  onOpen(callback: () => void) {
    this.bare.onopen = () => {
      callback();
    };
  }

  onReceive(callback: (data: string) => void) {
    this.bare.onmessage = (event) => {
      callback(event.data);
    };
  }

  onClose(callback: () => void) {
    this.bare.onclose = () => {
      callback();
    };
    // Failed connections also emit close. Handling both error and close here
    // would schedule two reconnects and leave one of the new sockets orphaned.
  }
}

export class ConnectionFactory {
  url: string;

  protocols: string[];

  constructor(url: string, protocols: string[]) {
    this.url = url;
    this.protocols = protocols;
  }

  create(): Connection {
    // Remove protocols for the time being. Our server doesn't respond currently to chrome/edge and
    // causes the connection setup to fail there. Specifically, the server needs to respond with the
    // 'Sec-WebSocket-Protocol: webtty' header when connecting.
    return new Connection(this.url, []);
  }
}
